import React from "react";
import PT from "prop-types";
import styled from "styled-components";

import { editorjs } from "./editorjs_vars";
import { ScrollAnim } from "~/src/components";

const EditorList = ({ type = "unordered", children }) => {
    return (
        <ScrollAnim type="slideInDownSmall" delay={0}>
            <SList className={`${type}`}>{children}</SList>
        </ScrollAnim>
    );
};

EditorList.propTypes = {
    type: PT.oneOf(["unordered", "ordered"]),
    children: PT.any,
};

const SList = styled.ul`
    padding: ${editorjs.block_padding};
    &.unordered {
        padding-left: 0;
        list-style: disc;
    }
    &.ordered {
        padding-left: 2em;
        list-style: decimal;
    }
`;

export default EditorList;
